window.app = window.app || {};

window.app.blog = {
  el: {
    featuredPostsSlider: document.querySelector('.mt-blog__featured-posts .swiper'),
    blogPostsSliders: document.querySelectorAll('.mt-blog__slider .swiper'),
  },
  featuredPostsSlider: null,

  init: function() {
    const _this = this;

    _this.initFeaturedPostsSlider(); 
    _this.initBlogPostsSlider();
  },

  initFeaturedPostsSlider: function() {
    const _this = this;
    if (!_this.el.featuredPostsSlider) return;
    
    _this.featuredPostsSlider = new Swiper(_this.el.featuredPostsSlider, {
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.mt-blog__featured-posts__arrow--next',
        prevEl: '.mt-blog__featured-posts__arrow--prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },    
    });
  },

  initBlogPostsSlider: function() {
    const _this = this;
    if (_this.el.blogPostsSliders.length === 0) return;
    _this.el.blogPostsSliders.forEach((slider) => {
      const swiper = new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1200: {
            spaceBetween: 48,
            slidesPerView: 3,
          }
        }
      });

      // Featured on Article page
      if (slider.closest('.template-article')) {
        const articles = slider.querySelectorAll('.mt-blog-item');
        articles.forEach(article => {
          const title = article.querySelector('.mt-blog-item__title');
          const links = article.querySelectorAll('a');
          links.forEach(link => {
            link.addEventListener('click', () => window.app.dl.blogRelatedArticleClick(title.innerText));
          });
        });
      }
    })
  }
};

window.app.blog.init();